module.exports = __webpack_public_path__ + "media/images/flags/1x1/jor-b33182a70187624631184e0fb551b295.svg";